export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_MESSAGES_USERS = 'SET_MESSAGES_USERS';
